var _circle, _rect, _rect2, _path, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotDesktopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#212935"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    x: 4.28516,
    y: 9.42969,
    width: 27.4286,
    height: 15.4286,
    rx: 7.71429,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    x: 7.71484,
    y: 12,
    width: 20.5714,
    height: 10.2857,
    rx: 5.14286,
    fill: "#212935"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M22.4844 28.8004L28.5844 22.9004L22.4844 23.4004V28.8004Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 12.2,
    cy: 17.0008,
    r: 1.2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 12.2,
    cy: 17.0008,
    r: 1.2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 23.7996,
    cy: 17.0008,
    r: 1.2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotDesktopIcon);
export default __webpack_public_path__ + "static/media/chatbot-desktop-icon.23694246919871a8ef7ee4e0731e25b8.svg";
export { ForwardRef as ReactComponent };